import { ServiceDropdownWUT } from '@wix/form-fields/viewer-wut';

export default ServiceDropdownWUT;
